var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"receipt-88"},[_c('div',{staticStyle:{"width":"88mm"},domProps:{"innerHTML":_vm._s(_vm.receiptHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }